import React from "react";
import * as actions from '../Actions';
export default function ShareMileOverlay({eleRef,tool}){
    return(
    <div className="shareMile-overlay" onClick={()=>{eleRef.shareMileCloseButton()}}>
        <div className="shareMile-popup">
            <div className="shareMile-container">
                <span className="closeButton icon" data-icon-font="C" onClick={() => { eleRef.shareMileCloseButton() }}></span>
                <div className="shareImg-container">
                    <img id="shareMileImg" src="https://cdn.fcglcdn.com/brainbees/community/memoryimages/1560839278549-1560839106.jpg" />
                </div>
                <div className="shareInfo-container">
                    <div className="startShareText">Start Sharing Now !!</div>
                    <span className="R17_61">
                        Your picture has been successfully posted. Now share eleRef picture with family & friends and spread the joy of Parenthood.
                    </span>
                    <div className="shareMileIcons">
                        <span className="icon R28_9e" data-text="facebook">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/Images_folder/facebook.png" onClick={(e) => actions.shareArticleFrame(document.querySelector('#shareMileImg').src, 'facebook')} /></span>
                        <span className="icon R28_9e" data-text="twitter">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/Images_folder/twitter.png" onClick={(e) => actions.shareArticleFrame(document.querySelector('#shareMileImg').src, 'twitter')} /></span>
                        <span className="icon R28_9e" data-text="pinterest">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/Images_folder/pintrest.png" onClick={(e) => actions.shareArticleFrame(document.querySelector('#shareMileImg').src, 'pintrest')} /></span>
                        <span className="icon R28_9e" data-text="whatsapp">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/Images_folder/whatsapp.png" onClick={(e) => actions.shareArticleFrame(document.querySelector('#shareMileImg').src, 'whatsapp')} /></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}
